export const virtualAccountNumberFormatter = (accountNumber?: string) => {
  if (!accountNumber) return null;
  return accountNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1 $2 $3');
};
